import script from "./CsvTagUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CsvTagUpload.vue?vue&type=script&setup=true&lang=js"

import "./CsvTagUpload.vue?vue&type=style&index=0&id=07086bdc&lang=scss"

const __exports__ = script;

export default __exports__